import React from 'react';
import { makeStyles } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { BaseTypography } from '../BaseTypography/BaseTypography';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 0,
  },
  closeButton: {
    marginTop: '3px',
    color: '2C4143',
    padding: '0',
    alignSelf: 'flex-start',
  },
});

type BaseDialogTitleProps = {
  onClose?: () => any;
};

export const BaseDialogTitle: React.FC<BaseDialogTitleProps> = (props) => {
  const { children, onClose, ...other } = props;
  const classes = useStyles();
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <BaseTypography variant="h4">{children}</BaseTypography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};
